import { useEffect } from 'react';

import { projectInfoVar } from 'API/variables';
import { TrackingService } from 'services/Tracking';


export const DATADOG_CONFIG = {
  applicationId: '364aa24a-41a9-40b9-8e90-38ac5df0ee3a',
  clientToken: 'pub22ce5b4693d0ed7d4318502dcd9f4d19',
  site: 'datadoghq.eu',
  service: 'mysurvey',
  sessionSampleRate: 100,
  sessionReplaySampleRate: 20,
  defaultPrivacyLevel: 'mask-user-input',
  trackUserInteractions: true,
  trackResources: true,
  trackLongTasks: true,
};

const Tracking = () => {
  const projectInfo = projectInfoVar();

  useEffect(() => {
    if (!projectInfo?.code) return;

    TrackingService.getInstance().initializeTracking();

    if (!projectInfo?.GTMCode) return;

    if (!window.dataLayer) {
      window.dataLayer = [];
    }

    const existingGtmScript = document.querySelector(`script[src*="googletagmanager.com/gtm.js?id=${projectInfo.GTMCode}"]`);

    if (!existingGtmScript) {
      const script = document.createElement('script');
      script.innerHTML = `
          (function (w, d, s, l, i) {
            w[l] = w[l] || [];
            w[l].push({ "gtm.start": new Date().getTime(), event: "gtm.js" });
            var f = d.getElementsByTagName(s)[0],
              j = d.createElement(s),
              dl = l != "dataLayer" ? "&l=" + l : "";
            j.async = true;
            j.src = "https://www.googletagmanager.com/gtm.js?id=" + i + dl;
            f.parentNode.insertBefore(j, f);
          })(window, document, "script", "dataLayer", "${projectInfo.GTMCode}");
        `;
      script.async = true;
      document.head.appendChild(script);

      const noscript = document.createElement('noscript');
      const iframe = document.createElement('iframe');
      iframe.src = `https://www.googletagmanager.com/ns.html?id=${projectInfo.GTMCode}`;
      iframe.height = '0';
      iframe.width = '0';
      iframe.style.display = 'none';
      iframe.style.visibility = 'hidden';
      noscript.appendChild(iframe);
      document.body.appendChild(noscript);
    }
  }, [projectInfo?.code]);

  return null;
};

export default Tracking;
